import { emailVariables, ticketVariables, approvalVariables, alarmVariables } from './common';

export const textAngularConfig = [
    '$provide', ($provide) => {
        $provide.decorator('taOptions', [
            'taRegisterTool', '$delegate', (taRegisterTool, taOptions) => {
                taRegisterTool('variables', {
                    display: '<div class="bar-btn-dropdown dropdown">' +
                        '<button class="btn btn-sm btn-default dropdown-toggle" type="button" ng-disabled="showHtml()" style="padding-top: 4px" data-toggle="dropdown"><i class="fa fa-list-alt fa-fw"></i><i class="fa fa-caret-down"></i></button>'
                        +
                        '<ul class="dropdown-menu"><li ng-repeat="o in options" ng-class="o.css"><span ng-if="o.name" style="margin:15px;" type="button" ng-click="action($event, o.value)">{{o.name|translate}}</span></li></ul></div>',
                    action: function (event, value) {
                        if (event.preventDefault) {
                            event.preventDefault();
                            this.$editor().wrapSelection('insertText', value);
                            return true;
                        }
                        else {
                            return false;
                        }
                    },
                    options: emailVariables,
                });
                taRegisterTool('alarmVariables', buildButton('fa-bell-o', 'Alarm', alarmVariables));
                taRegisterTool('approvalVariables', buildButton('fa-thumbs-o-up', 'Approval', approvalVariables));
                taRegisterTool('ticketVariables', buildButton('fa-ticket', 'Ticket', ticketVariables));
                return taOptions;
            }
        ]);
    }
];


function buildButton(icon: string, type: string, options: { name: string; value: string }[]) {
    return {
        display:
            `<div class="bar-btn-dropdown dropdown" title="{{'${type} related variables'|translate}}">
<button class="btn btn-sm btn-default dropdown-toggle" type="button" ng-disabled="showHtml()" style="padding-top: 4px" data-toggle="dropdown">
<i class="fa fa-fw ${icon}"></i><i class="fa fa-caret-down"></i>
</button>
<ul class="dropdown-menu">
<li ng-repeat="o in options" ng-class="o.css">
<span ng-if="o.name" style="margin:15px;" type="button" ng-click="action($event, o.value)">
{{o.name|translate}}
</span>
</li>
</ul>
</div>`,
        action: function (event, value) {
            if (event.preventDefault) {
                event.preventDefault();
                this.$editor().wrapSelection('insertText', value, true);
                return true;
            }
            else {
                return false;
            }
        },
        options: options
    };
}